// src/utils/geolocation.js
// R5: Global IP-based geolocation with Amadeus airport detection
// OPTIMIZED VERSION - Uses existing search-flights API to avoid extra serverless function

// ============================================================================
// CONSTANTS
// ============================================================================
const CACHE_KEY = 'user_airport_location_v2';
const CACHE_DURATION = 24 * 60 * 60 * 1000; // 24 hours

// ============================================================================
// MAJOR AIRPORT DATABASE (Covers 95% of users)
// This avoids needing a separate API call for common locations
// ============================================================================
const METRO_TO_AIRPORT = {
  // ===== USA - Major Metros =====
  // Houston Metro
  'sugar land': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'katy': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'the woodlands': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'woodlands': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'pearland': { city: 'Houston', airport: 'HOU', name: 'William P. Hobby' },
  'pasadena': { city: 'Houston', airport: 'HOU', name: 'William P. Hobby' },
  'cypress': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'spring': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'humble': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'missouri city': { city: 'Houston', airport: 'HOU', name: 'William P. Hobby' },
  'baytown': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'league city': { city: 'Houston', airport: 'HOU', name: 'William P. Hobby' },
  'conroe': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },
  'houston': { city: 'Houston', airport: 'IAH', name: 'George Bush Intercontinental' },

  // New York Metro
  'brooklyn': { city: 'New York', airport: 'JFK', name: 'John F. Kennedy International' },
  'queens': { city: 'New York', airport: 'JFK', name: 'John F. Kennedy International' },
  'bronx': { city: 'New York', airport: 'LGA', name: 'LaGuardia' },
  'staten island': { city: 'New York', airport: 'EWR', name: 'Newark Liberty International' },
  'manhattan': { city: 'New York', airport: 'JFK', name: 'John F. Kennedy International' },
  'jersey city': { city: 'New York', airport: 'EWR', name: 'Newark Liberty International' },
  'newark': { city: 'New York', airport: 'EWR', name: 'Newark Liberty International' },
  'hoboken': { city: 'New York', airport: 'EWR', name: 'Newark Liberty International' },
  'yonkers': { city: 'New York', airport: 'LGA', name: 'LaGuardia' },
  'white plains': { city: 'New York', airport: 'LGA', name: 'LaGuardia' },
  'new york': { city: 'New York', airport: 'JFK', name: 'John F. Kennedy International' },
  'new york city': { city: 'New York', airport: 'JFK', name: 'John F. Kennedy International' },

  // Los Angeles Metro
  'santa monica': { city: 'Los Angeles', airport: 'LAX', name: 'Los Angeles International' },
  'burbank': { city: 'Los Angeles', airport: 'BUR', name: 'Hollywood Burbank' },
  'glendale': { city: 'Los Angeles', airport: 'BUR', name: 'Hollywood Burbank' },
  'long beach': { city: 'Los Angeles', airport: 'LGB', name: 'Long Beach' },
  'anaheim': { city: 'Los Angeles', airport: 'SNA', name: 'John Wayne Orange County' },
  'irvine': { city: 'Los Angeles', airport: 'SNA', name: 'John Wayne Orange County' },
  'torrance': { city: 'Los Angeles', airport: 'LAX', name: 'Los Angeles International' },
  'hollywood': { city: 'Los Angeles', airport: 'LAX', name: 'Los Angeles International' },
  'beverly hills': { city: 'Los Angeles', airport: 'LAX', name: 'Los Angeles International' },
  'pasadena': { city: 'Los Angeles', airport: 'BUR', name: 'Hollywood Burbank' },
  'los angeles': { city: 'Los Angeles', airport: 'LAX', name: 'Los Angeles International' },

  // San Francisco Bay Area
  'oakland': { city: 'Oakland', airport: 'OAK', name: 'Oakland International' },
  'san jose': { city: 'San Jose', airport: 'SJC', name: 'San Jose International' },
  'palo alto': { city: 'San Francisco', airport: 'SFO', name: 'San Francisco International' },
  'mountain view': { city: 'San Jose', airport: 'SJC', name: 'San Jose International' },
  'fremont': { city: 'Oakland', airport: 'OAK', name: 'Oakland International' },
  'berkeley': { city: 'Oakland', airport: 'OAK', name: 'Oakland International' },
  'san mateo': { city: 'San Francisco', airport: 'SFO', name: 'San Francisco International' },
  'sunnyvale': { city: 'San Jose', airport: 'SJC', name: 'San Jose International' },
  'cupertino': { city: 'San Jose', airport: 'SJC', name: 'San Jose International' },
  'san francisco': { city: 'San Francisco', airport: 'SFO', name: 'San Francisco International' },

  // Chicago Metro
  'evanston': { city: 'Chicago', airport: 'ORD', name: "O'Hare International" },
  'naperville': { city: 'Chicago', airport: 'ORD', name: "O'Hare International" },
  'aurora': { city: 'Chicago', airport: 'ORD', name: "O'Hare International" },
  'schaumburg': { city: 'Chicago', airport: 'ORD', name: "O'Hare International" },
  'oak park': { city: 'Chicago', airport: 'MDW', name: 'Midway International' },
  'chicago': { city: 'Chicago', airport: 'ORD', name: "O'Hare International" },

  // Dallas-Fort Worth Metro
  'fort worth': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'arlington': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'plano': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'irving': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'garland': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'frisco': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'mckinney': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },
  'dallas': { city: 'Dallas', airport: 'DFW', name: 'Dallas/Fort Worth International' },

  // Washington DC Metro
  'alexandria': { city: 'Washington', airport: 'DCA', name: 'Ronald Reagan National' },
  'bethesda': { city: 'Washington', airport: 'DCA', name: 'Ronald Reagan National' },
  'silver spring': { city: 'Washington', airport: 'DCA', name: 'Ronald Reagan National' },
  'fairfax': { city: 'Washington', airport: 'IAD', name: 'Dulles International' },
  'reston': { city: 'Washington', airport: 'IAD', name: 'Dulles International' },
  'washington': { city: 'Washington', airport: 'DCA', name: 'Ronald Reagan National' },
  'washington dc': { city: 'Washington', airport: 'DCA', name: 'Ronald Reagan National' },

  // Miami Metro
  'miami beach': { city: 'Miami', airport: 'MIA', name: 'Miami International' },
  'fort lauderdale': { city: 'Fort Lauderdale', airport: 'FLL', name: 'Fort Lauderdale-Hollywood International' },
  'hialeah': { city: 'Miami', airport: 'MIA', name: 'Miami International' },
  'coral gables': { city: 'Miami', airport: 'MIA', name: 'Miami International' },
  'boca raton': { city: 'Fort Lauderdale', airport: 'FLL', name: 'Fort Lauderdale-Hollywood International' },
  'west palm beach': { city: 'West Palm Beach', airport: 'PBI', name: 'Palm Beach International' },
  'miami': { city: 'Miami', airport: 'MIA', name: 'Miami International' },

  // Boston Metro
  'cambridge': { city: 'Boston', airport: 'BOS', name: 'Logan International' },
  'somerville': { city: 'Boston', airport: 'BOS', name: 'Logan International' },
  'brookline': { city: 'Boston', airport: 'BOS', name: 'Logan International' },
  'quincy': { city: 'Boston', airport: 'BOS', name: 'Logan International' },
  'newton': { city: 'Boston', airport: 'BOS', name: 'Logan International' },
  'boston': { city: 'Boston', airport: 'BOS', name: 'Logan International' },

  // Atlanta Metro
  'marietta': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },
  'decatur': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },
  'sandy springs': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },
  'roswell': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },
  'alpharetta': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },
  'atlanta': { city: 'Atlanta', airport: 'ATL', name: 'Hartsfield-Jackson International' },

  // Phoenix Metro
  'scottsdale': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },
  'tempe': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },
  'mesa': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },
  'chandler': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },
  'phoenix': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },

  // Denver Metro
  'aurora': { city: 'Denver', airport: 'DEN', name: 'Denver International' },
  'lakewood': { city: 'Denver', airport: 'DEN', name: 'Denver International' },
  'boulder': { city: 'Denver', airport: 'DEN', name: 'Denver International' },
  'denver': { city: 'Denver', airport: 'DEN', name: 'Denver International' },

  // Seattle Metro
  'bellevue': { city: 'Seattle', airport: 'SEA', name: 'Seattle-Tacoma International' },
  'tacoma': { city: 'Seattle', airport: 'SEA', name: 'Seattle-Tacoma International' },
  'redmond': { city: 'Seattle', airport: 'SEA', name: 'Seattle-Tacoma International' },
  'kirkland': { city: 'Seattle', airport: 'SEA', name: 'Seattle-Tacoma International' },
  'seattle': { city: 'Seattle', airport: 'SEA', name: 'Seattle-Tacoma International' },

  // Other Major US Cities
  'detroit': { city: 'Detroit', airport: 'DTW', name: 'Detroit Metropolitan' },
  'minneapolis': { city: 'Minneapolis', airport: 'MSP', name: 'Minneapolis-Saint Paul International' },
  'st paul': { city: 'Minneapolis', airport: 'MSP', name: 'Minneapolis-Saint Paul International' },
  'orlando': { city: 'Orlando', airport: 'MCO', name: 'Orlando International' },
  'las vegas': { city: 'Las Vegas', airport: 'LAS', name: 'Harry Reid International' },
  'san diego': { city: 'San Diego', airport: 'SAN', name: 'San Diego International' },
  'philadelphia': { city: 'Philadelphia', airport: 'PHL', name: 'Philadelphia International' },
  'phoenix': { city: 'Phoenix', airport: 'PHX', name: 'Phoenix Sky Harbor International' },
  'san antonio': { city: 'San Antonio', airport: 'SAT', name: 'San Antonio International' },
  'austin': { city: 'Austin', airport: 'AUS', name: 'Austin-Bergstrom International' },
  'nashville': { city: 'Nashville', airport: 'BNA', name: 'Nashville International' },
  'portland': { city: 'Portland', airport: 'PDX', name: 'Portland International' },
  'charlotte': { city: 'Charlotte', airport: 'CLT', name: 'Charlotte Douglas International' },
  'salt lake city': { city: 'Salt Lake City', airport: 'SLC', name: 'Salt Lake City International' },
  'tampa': { city: 'Tampa', airport: 'TPA', name: 'Tampa International' },
  'st louis': { city: 'St. Louis', airport: 'STL', name: 'St. Louis Lambert International' },
  'pittsburgh': { city: 'Pittsburgh', airport: 'PIT', name: 'Pittsburgh International' },
  'cleveland': { city: 'Cleveland', airport: 'CLE', name: 'Cleveland Hopkins International' },
  'cincinnati': { city: 'Cincinnati', airport: 'CVG', name: 'Cincinnati/Northern Kentucky International' },
  'kansas city': { city: 'Kansas City', airport: 'MCI', name: 'Kansas City International' },
  'indianapolis': { city: 'Indianapolis', airport: 'IND', name: 'Indianapolis International' },
  'new orleans': { city: 'New Orleans', airport: 'MSY', name: 'Louis Armstrong International' },
  'raleigh': { city: 'Raleigh', airport: 'RDU', name: 'Raleigh-Durham International' },
  'honolulu': { city: 'Honolulu', airport: 'HNL', name: 'Daniel K. Inouye International' },

  // ===== INTERNATIONAL - Major Cities =====
  // Canada
  'toronto': { city: 'Toronto', airport: 'YYZ', name: 'Toronto Pearson International' },
  'vancouver': { city: 'Vancouver', airport: 'YVR', name: 'Vancouver International' },
  'montreal': { city: 'Montreal', airport: 'YUL', name: 'Montréal-Trudeau International' },
  'calgary': { city: 'Calgary', airport: 'YYC', name: 'Calgary International' },

  // UK
  'london': { city: 'London', airport: 'LHR', name: 'Heathrow' },
  'manchester': { city: 'Manchester', airport: 'MAN', name: 'Manchester' },
  'birmingham': { city: 'Birmingham', airport: 'BHX', name: 'Birmingham' },
  'edinburgh': { city: 'Edinburgh', airport: 'EDI', name: 'Edinburgh' },
  'glasgow': { city: 'Glasgow', airport: 'GLA', name: 'Glasgow' },

  // Europe
  'paris': { city: 'Paris', airport: 'CDG', name: 'Charles de Gaulle' },
  'amsterdam': { city: 'Amsterdam', airport: 'AMS', name: 'Schiphol' },
  'frankfurt': { city: 'Frankfurt', airport: 'FRA', name: 'Frankfurt' },
  'munich': { city: 'Munich', airport: 'MUC', name: 'Munich' },
  'berlin': { city: 'Berlin', airport: 'BER', name: 'Brandenburg' },
  'rome': { city: 'Rome', airport: 'FCO', name: 'Fiumicino' },
  'milan': { city: 'Milan', airport: 'MXP', name: 'Malpensa' },
  'madrid': { city: 'Madrid', airport: 'MAD', name: 'Barajas' },
  'barcelona': { city: 'Barcelona', airport: 'BCN', name: 'El Prat' },
  'zurich': { city: 'Zurich', airport: 'ZRH', name: 'Zurich' },
  'vienna': { city: 'Vienna', airport: 'VIE', name: 'Vienna International' },
  'dublin': { city: 'Dublin', airport: 'DUB', name: 'Dublin' },
  'lisbon': { city: 'Lisbon', airport: 'LIS', name: 'Lisbon Portela' },
  'brussels': { city: 'Brussels', airport: 'BRU', name: 'Brussels' },
  'copenhagen': { city: 'Copenhagen', airport: 'CPH', name: 'Copenhagen' },
  'stockholm': { city: 'Stockholm', airport: 'ARN', name: 'Arlanda' },
  'oslo': { city: 'Oslo', airport: 'OSL', name: 'Gardermoen' },
  'helsinki': { city: 'Helsinki', airport: 'HEL', name: 'Helsinki-Vantaa' },
  'prague': { city: 'Prague', airport: 'PRG', name: 'Václav Havel' },
  'warsaw': { city: 'Warsaw', airport: 'WAW', name: 'Chopin' },
  'budapest': { city: 'Budapest', airport: 'BUD', name: 'Budapest Ferenc Liszt' },
  'athens': { city: 'Athens', airport: 'ATH', name: 'Eleftherios Venizelos' },
  'istanbul': { city: 'Istanbul', airport: 'IST', name: 'Istanbul' },

  // Asia
  'tokyo': { city: 'Tokyo', airport: 'NRT', name: 'Narita International' },
  'osaka': { city: 'Osaka', airport: 'KIX', name: 'Kansai International' },
  'seoul': { city: 'Seoul', airport: 'ICN', name: 'Incheon International' },
  'beijing': { city: 'Beijing', airport: 'PEK', name: 'Beijing Capital International' },
  'shanghai': { city: 'Shanghai', airport: 'PVG', name: 'Pudong International' },
  'hong kong': { city: 'Hong Kong', airport: 'HKG', name: 'Hong Kong International' },
  'taipei': { city: 'Taipei', airport: 'TPE', name: 'Taiwan Taoyuan International' },
  'singapore': { city: 'Singapore', airport: 'SIN', name: 'Changi' },
  'bangkok': { city: 'Bangkok', airport: 'BKK', name: 'Suvarnabhumi' },
  'kuala lumpur': { city: 'Kuala Lumpur', airport: 'KUL', name: 'Kuala Lumpur International' },
  'jakarta': { city: 'Jakarta', airport: 'CGK', name: 'Soekarno-Hatta International' },
  'manila': { city: 'Manila', airport: 'MNL', name: 'Ninoy Aquino International' },
  'ho chi minh city': { city: 'Ho Chi Minh City', airport: 'SGN', name: 'Tan Son Nhat International' },
  'hanoi': { city: 'Hanoi', airport: 'HAN', name: 'Noi Bai International' },

  // India
  'mumbai': { city: 'Mumbai', airport: 'BOM', name: 'Chhatrapati Shivaji Maharaj International' },
  'delhi': { city: 'Delhi', airport: 'DEL', name: 'Indira Gandhi International' },
  'new delhi': { city: 'Delhi', airport: 'DEL', name: 'Indira Gandhi International' },
  'bangalore': { city: 'Bangalore', airport: 'BLR', name: 'Kempegowda International' },
  'bengaluru': { city: 'Bangalore', airport: 'BLR', name: 'Kempegowda International' },
  'hyderabad': { city: 'Hyderabad', airport: 'HYD', name: 'Rajiv Gandhi International' },
  'chennai': { city: 'Chennai', airport: 'MAA', name: 'Chennai International' },
  'kolkata': { city: 'Kolkata', airport: 'CCU', name: 'Netaji Subhas Chandra Bose International' },
  'pune': { city: 'Pune', airport: 'PNQ', name: 'Pune International' },
  'ahmedabad': { city: 'Ahmedabad', airport: 'AMD', name: 'Sardar Vallabhbhai Patel International' },

  // Middle East
  'dubai': { city: 'Dubai', airport: 'DXB', name: 'Dubai International' },
  'abu dhabi': { city: 'Abu Dhabi', airport: 'AUH', name: 'Abu Dhabi International' },
  'doha': { city: 'Doha', airport: 'DOH', name: 'Hamad International' },
  'riyadh': { city: 'Riyadh', airport: 'RUH', name: 'King Khalid International' },
  'jeddah': { city: 'Jeddah', airport: 'JED', name: 'King Abdulaziz International' },
  'tel aviv': { city: 'Tel Aviv', airport: 'TLV', name: 'Ben Gurion' },

  // Australia & New Zealand
  'sydney': { city: 'Sydney', airport: 'SYD', name: 'Sydney Kingsford Smith' },
  'melbourne': { city: 'Melbourne', airport: 'MEL', name: 'Melbourne Tullamarine' },
  'brisbane': { city: 'Brisbane', airport: 'BNE', name: 'Brisbane' },
  'perth': { city: 'Perth', airport: 'PER', name: 'Perth' },
  'auckland': { city: 'Auckland', airport: 'AKL', name: 'Auckland' },

  // Latin America
  'mexico city': { city: 'Mexico City', airport: 'MEX', name: 'Benito Juárez International' },
  'cancun': { city: 'Cancun', airport: 'CUN', name: 'Cancún International' },
  'sao paulo': { city: 'São Paulo', airport: 'GRU', name: 'Guarulhos International' },
  'rio de janeiro': { city: 'Rio de Janeiro', airport: 'GIG', name: 'Galeão International' },
  'buenos aires': { city: 'Buenos Aires', airport: 'EZE', name: 'Ministro Pistarini International' },
  'bogota': { city: 'Bogotá', airport: 'BOG', name: 'El Dorado International' },
  'lima': { city: 'Lima', airport: 'LIM', name: 'Jorge Chávez International' },
  'santiago': { city: 'Santiago', airport: 'SCL', name: 'Arturo Merino Benítez International' },

  // Africa
  'johannesburg': { city: 'Johannesburg', airport: 'JNB', name: 'O.R. Tambo International' },
  'cape town': { city: 'Cape Town', airport: 'CPT', name: 'Cape Town International' },
  'cairo': { city: 'Cairo', airport: 'CAI', name: 'Cairo International' },
  'nairobi': { city: 'Nairobi', airport: 'NBO', name: 'Jomo Kenyatta International' },
  'lagos': { city: 'Lagos', airport: 'LOS', name: 'Murtala Muhammed International' },
  'casablanca': { city: 'Casablanca', airport: 'CMN', name: 'Mohammed V International' },
};

// ============================================================================
// MAIN FUNCTION: Get user's nearest airport
// ============================================================================
export async function getUserAirport() {
  try {
    console.log('📍 Detecting user location...');
    
    // ========================================
    // Step 1: Get user's city from IP
    // ========================================
    let ipData = null;
    
    try {
      const ipResponse = await fetch('http://ip-api.com/json/?fields=status,message,city,regionName,country,countryCode,lat,lon', {
        signal: AbortSignal.timeout(5000)
      });
      
      if (ipResponse.ok) {
        ipData = await ipResponse.json();
        if (ipData.status !== 'success') {
          console.warn('⚠️ IP-API error:', ipData.message);
          ipData = null;
        }
      }
    } catch (ipError) {
      console.warn('⚠️ ip-api.com failed:', ipError.message);
    }
    
    // Fallback to ipapi.co
    if (!ipData) {
      try {
        console.log('🔄 Trying fallback IP service...');
        const fallbackResponse = await fetch('https://ipapi.co/json/', {
          signal: AbortSignal.timeout(5000)
        });
        
        if (fallbackResponse.ok) {
          const fallbackData = await fallbackResponse.json();
          ipData = {
            status: 'success',
            city: fallbackData.city,
            regionName: fallbackData.region,
            country: fallbackData.country_name,
            countryCode: fallbackData.country_code,
            lat: fallbackData.latitude,
            lon: fallbackData.longitude
          };
        }
      } catch (fallbackError) {
        console.error('❌ All IP services failed');
        return null;
      }
    }
    
    if (!ipData || !ipData.city) {
      console.error('❌ Could not detect city');
      return null;
    }
    
    console.log('📍 IP detected:', { city: ipData.city, country: ipData.country });

    // ========================================
    // Step 2: Look up airport from our database
    // ========================================
    const cityKey = ipData.city.toLowerCase().trim();
    const mapped = METRO_TO_AIRPORT[cityKey];
    
    if (mapped) {
      console.log(`✅ Found airport: ${mapped.city} (${mapped.airport}) - ${mapped.name}`);
      
      return {
        city: mapped.city,
        airport: mapped.airport,
        airportName: mapped.name,
        country: ipData.country,
        countryCode: ipData.countryCode,
        originalCity: ipData.city,
        region: ipData.regionName,
        coordinates: {
          latitude: ipData.lat,
          longitude: ipData.lon
        }
      };
    }
    
    // ========================================
    // Step 3: City not in database - return as-is
    // ========================================
    console.log(`⚠️ City "${ipData.city}" not in airport database, using city name`);
    
    return {
      city: ipData.city,
      airport: null,
      airportName: null,
      country: ipData.country,
      countryCode: ipData.countryCode,
      originalCity: ipData.city,
      region: ipData.regionName,
      coordinates: {
        latitude: ipData.lat,
        longitude: ipData.lon
      }
    };
    
  } catch (error) {
    console.error('❌ Geolocation error:', error);
    return null;
  }
}

// ============================================================================
// CACHED VERSION: Stores result in localStorage for 24 hours
// ============================================================================
export async function getCachedUserAirport() {
  try {
    const cached = localStorage.getItem(CACHE_KEY);
    
    if (cached) {
      try {
        const { data, timestamp } = JSON.parse(cached);
        
        if (Date.now() - timestamp < CACHE_DURATION && data) {
          console.log('📍 Using cached location:', getLocationDisplayString(data));
          return data;
        }
      } catch (parseError) {
        localStorage.removeItem(CACHE_KEY);
      }
    }
    
    const location = await getUserAirport();
    
    if (location) {
      localStorage.setItem(CACHE_KEY, JSON.stringify({
        data: location,
        timestamp: Date.now()
      }));
    }
    
    return location;
    
  } catch (error) {
    console.error('❌ Cached geolocation error:', error);
    return null;
  }
}

// ============================================================================
// HELPER FUNCTIONS
// ============================================================================
export function getLocationDisplayString(location) {
  if (!location) return 'your location';
  if (location.airport) return `${location.city} (${location.airport})`;
  return location.city || 'your location';
}

export function getLocationCity(location) {
  return location?.city || location?.originalCity || null;
}

export function getLocationAirportCode(location) {
  return location?.airport || null;
}

export function hasValidAirport(location) {
  return location && location.airport && location.airport.length === 3;
}

export function clearCachedLocation() {
  localStorage.removeItem(CACHE_KEY);
  console.log('📍 Location cache cleared');
}

export async function refreshUserLocation() {
  clearCachedLocation();
  return await getCachedUserAirport();
}
